module.exports = __webpack_public_path__ + "static/img/myqrLogo.db000f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myqrLogo.png
// module id = 2RTS
// module chunks = 1